import styled from 'styled-components/macro';

export const ImagePreviewerContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
    width: 100%;
    align-self: center;
    margin: auto;
  }
`;
